<template>
  <b-container fluid class="usuario-screen">
      <span class="premium-tag"  @click="showModalPremium('show')">
          <i class="far fa-star"></i>&nbsp;
          <b>Premium</b>
      </span>
       <!-- MODAL CADASTRO DE USUARIO -->
       <ModalCadastro :id="selectedId" :visible="visibleModalCadastro" />

       <el-tabs type="border-card">
            <el-tab-pane>
              <span slot="label"> Usuários </span>

               <container-card fixed id="cadastroDeUsuario" icon="el-icon-user" title="Usuários cadastrados">
                
                  <!-- btn-cadastrar novo usuario e modal -->
                  <div id="criarNovoUsuario" @click="novoUsuario" class="add-button" v-if="!regraAcessoUsuario"
                      v-b-popover.hover.top="'Adicionar novo Usuário.'">
                      <i class="fas fa-plus"></i>
                  </div>
                   <b-card>
                    <el-alert
                      v-if="regraAcessoUsuario"
                      title="Limite de usuários atingido, seja premium para cadastrar novos"
                      type="info"
                      show-icon>
                    </el-alert>
                       <el-table
                           class="p-table"
                           v-loading="tableOptions.load"
                           :data="tableOptions.data"
                           style="width: 100%"
                           stripe
                           border
                           size="mini">
                            
                           <el-table-column prop="nome" label="Nome" align="left">
                              <template slot="header" slot-scope="scope">
                                Nome do usuário
                                <el-popover
                                ref="filterNome"
                                placement="bottom"
                                trigger="click"
                                width="400">
                                    <div>
                                      <el-input class="input-filter" placeholder="Pesquisar nome" v-model="model.nome" size="mini"></el-input>
                                    </div>
                                    <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                                    <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nome')">Limpar</el-button>
                                    <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                                </el-popover>
                            </template>
                           </el-table-column>

                           <el-table-column prop="nomeDaRegraDeAcesso" align="left">
                              <template slot="header" slot-scope="scope">
                                Regra de Acessos
                                <el-popover
                                ref="filterRegra"
                                placement="bottom"
                                trigger="click"
                                width="400">
                                    <div>
                                      <el-input class="input-filter" placeholder="Pesquisar regra" v-model="model.nomeDaRegraDeAcesso" size="mini"></el-input>
                                    </div>
                                    <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                                    <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nomeDaRegraDeAcesso')">Limpar</el-button>
                                    <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                                </el-popover>
                            </template>
                           </el-table-column>

                           <el-table-column prop="email" align="left">
                              <template slot="header" slot-scope="scope">
                                E-mail
                                <el-popover
                                ref="filterEmail"
                                placement="bottom"
                                trigger="click"
                                width="400">
                                    <div>
                                      <el-input class="input-filter" placeholder="Pesquisar e-mail" v-model="model.email" size="mini"></el-input>
                                    </div>
                                    <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                                    <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('email')">Limpar</el-button>
                                    <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                                </el-popover>
                            </template>
                           </el-table-column>
                          

                           <el-table-column
                               fixed="right"
                               label="Ativo"
                               width="100"
                               align="center">
                               <template slot="header" slot-scope="scope">
                                  Ativo
                                  <el-popover
                                  ref="filterAtivo"
                                  placement="bottom"
                                  trigger="click"
                                  width="400">
                                      <div>
                                        <el-select v-model="model.isApproved" placeholder="Selecione" size="mini" class="input-filter" style="width:100%">
                                          <el-option label="Todos" :value="null"></el-option>
                                          <el-option label="Ativos" :value="true"></el-option>
                                          <el-option label="Inativos" :value="false"></el-option>
                                        </el-select><br>
                                      </div>
                                      <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                                      <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('email')">Limpar</el-button>
                                      <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                                  </el-popover>
                              </template>

                               <template slot-scope="scope" v-if="scope.row">
                                   <el-tooltip v-if="scope.row.isApproved" class="item" effect="dark" content="Status: Ativo" placement="top-start">
                                       <i class="fas fa-circle text-success"></i>
                                   </el-tooltip>
                                   <el-tooltip v-if="!scope.row.isApproved" class="item" effect="dark" content="Status: Inativo" placement="top-start">
                                       <i class="fas fa-circle text-danger"></i>
                                   </el-tooltip>
                               </template>
                           </el-table-column>
                           <el-table-column
                               fixed="right"
                               label="Operações"
                               width="130"
                               align="center">
                               <template slot-scope="scope" v-if="scope.row">
                                   <el-button title="Editar usuário" class="mr-1 cursor-pointer" icon="el-icon-edit-outline" circle size="mini" type="primary" @click.native="editarUsuario(scope.row)"></el-button>
                                   <!-- <el-button title="Editar Senha" class="mr-1 cursor-pointer" icon="fas fa-lock" circle size="mini" type="warning" @click.native="handleResetPassword(scope.row)" style="margin: 0;"></el-button> -->
                                   <el-popover
                                       placement="top"
                                       width="250"
                                       :ref="`deletePop_${scope.$index}`">
                                       <p>Tem certeza que deseja deletar esse registro ?</p>
                                       <div style="text-align: right; margin: 0">
                                           <el-button type="secundary" size="mini" @click="deletarUsuarioOptOut(scope.$index)">Não</el-button>
                                           <el-button type="danger" size="mini" @click.native="deleteUsuario(scope.$index, scope.row)">Sim</el-button>
                                       </div>
                                       <el-button title="Deletar Usuário" class="cursor-pointer" slot="reference" icon="el-icon-delete" circle size="mini" type="danger"></el-button>
                                   </el-popover>
                               </template>
                           </el-table-column>
                       </el-table><br>
                       <el-pagination
                          class="text-center"
                          background
                          layout="sizes, prev, pager, next"
                          @size-change="paginacaoSize"
                          @current-change="paginacaoCurrent"
                          :page-size="tableOptions.paginacao.pageSize"
                          :current-page.sync="tableOptions.paginacao.page"
                          :total="tableOptions.paginacao.total"
                          :page-sizes="[5, 10, 25, 50, 75, 100]">
                      </el-pagination>
                      <el-button class="pull-right" size="small" type="success" style="margin-top:-30px" icon="el-icon-download" @click="requestDownload">Exportar modelo</el-button> 
                   </b-card>
               </container-card>
            </el-tab-pane>
            <el-tab-pane :disabled="!premiumUser()">
              <span slot="label"> Regra de Acesso </span>

              <RegraDeAcessos />
            </el-tab-pane>
       </el-tabs>
  </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import ModalCadastro from './modal/ModalCadastro'
import RegraDeAcessos from './RegraDeAcessos'

const model = () => {
  return {
    sort: "",
    order: "",
    nome: "",
    nomeDaRegraDeAcesso: '',
    email: "",
    isApproved: null,
  };
};

export default {
   name: 'Usuarios',
   components: {
       ContainerCard,
       ModalCadastro,
       RegraDeAcessos
   },
   props: {
       
   },
   data() {
       return {
          windowHeight: window.innerHeight,
          visibleModalCadastro: false,
          selectedId: '',
          model: model(),
          tableOptions: {
              load: false,
              data: [],
              paginacao: {
                  page: 1,
                  pageSize: 25,
                  total: 10
              }
          }
       }
   },
   computed: {
      tableHeight() {
        return this.windowHeight - 277
      },
      regraAcessoUsuario() {
        return !this.premiumUser() && this.tableOptions.paginacao.total >= 3
      }
   },
   methods: {
      paginacaoCurrent(val){
          this.tableOptions.paginacao.page = val
          this.listarUsuarios();
      },
      paginacaoSize(val){
          this.tableOptions.paginacao.pageSize = val
          this.tableOptions.paginacao.page = 1
          this.listarUsuarios();
      },
      limpar() {
        this.model = model();
        this.listaUsers = [];
      },
      novoUsuario(){
        this.selectedId = '';
        this.$bvModal.show('modal-cadastro-usuario')
      },
      setFilter() {
        this.tableOptions.paginacao.page = 1
        this.listarUsuarios();
      },
      clearFilter(name) {
        this.model[name] = ''
        this.listarUsuarios();
      },
      editarUsuario(row){
          this.selectedId = row._id;
          this.$bvModal.show('modal-cadastro-usuario')
      },
      async handleResetPassword({_id, nome}){
        this.$confirm('Tem certeza? essa ação irá redefinir a senha deste usuário.', 'Redefinir senha', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'não',
          type: 'warning'
        })
          .then(async (value) => {
            if(value){
              try {
                this.isLoading = true;
                const response =  await this.axios.put(`${this.$urls.RESET_USER_PASSWORD}?userId=${_id}`);
                  this.$notify({
                    group: 'foo',
                    title: `A senha foi redefinida para ${nome}`,
                    message: `${response.data}`,
                    duration: -1
                  });
                
              } catch (error) {
                const err =  Object.assign({}, error);
                console.log(err);
                const { data } = err.response;

                this.$notify({
                    group: 'foo',
                    title: 'Houve um erro no processo',
                    message: `${data}`,
                  });

              }finally{
                this.isLoading = false;
                this.pesquisarUsers();
              }
            
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      deletarUsuarioOptOut(index,label, grupo){
          if(grupo){
              this.$refs['deletePop_grupo_'+index][0].showPopper = false
              return false
          }
          if(label){
              this.$refs['deletePop_'+(label ? label : '')+index][0].showPopper = false
              return false
          }

          this.$refs['deletePop_'+(label ? label : '')+index].showPopper = false
          
      },
      async deleteUsuario(index, row) {
          let response = await this.axios.delete(this.$urls.DELETAR_USER, { params: {
              id: row._id
          }});

          if(response.status !== 200) {
              return;
          }

          this.$message({
              type: 'success',
              message: 'Usuário deletado com sucesso !'
          });

          this.listarUsuarios();
          this.$refs['deletePop_'+index].showPopper = false
      },
      getParams() {
        return {
          params: {
              page: this.tableOptions.paginacao.page,
              pageSize: this.tableOptions.paginacao.pageSize,
              sort: this.model.sort,
              order: this.model.order,
              nome: this.model.nome,
              nomeDaRegraDeAcesso: this.model.nomeDaRegraDeAcesso,
              email: this.model.email,
              isApproved: this.model.isApproved
            }
        };
      },  
      async listarUsuarios() {
        const params = this.getParams()
        try {
            this.tableOptions.load = true
            const response = await this.axios.get(this.$urls.OBTER_USERS, params);

            if(response.status !== 200) {
                this.$notify.error({
                    title: 'Listar usuários',
                    message: `Não foi possível obter a lista de usuários`,
                    position:'top-left'
                });
              return
            }
            this.tableOptions.data = response.data.users;
            this.tableOptions.paginacao.page = response.data.page;
            this.tableOptions.paginacao.total = response.data.total;

          } catch(err) {
              this.$notify.error({
                      title: 'Erro interno',
                      message: err.response ? err.response.data : `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                      position:'top-left'
                  });
          } finally {
            this.tableOptions.load = false
          }
      },
      callbackDownload(){
          this.tableOptions.load = false;
          this.$message.success('Download concluido.');
      },
      requestDownload(){
          this.tableOptions.load = true;
          this.$blob.getDownload(`${this.$urls.USUARIOS_DOWNLOAD_MODELO}`, this.callbackDownload) 
      }
   },
   mounted() {
       window.addEventListener('resize', () => {
           this.windowHeight = window.innerHeight
       });

       this.listarUsuarios();
   }
};
</script>
<style lang='scss' scoped>
.input-filter {
  margin-bottom: 5px;
}
   .add-button{
       width: 51px;
       padding: 14px 0;
       background: #343a40;
       color: #fff;
       text-align: center;
       border-radius: 50%;
       position: fixed;
       z-index: 10;
       cursor: pointer;
       bottom: 6px;
       margin-left: 3px;
   }
</style>
<style lang="scss">
.usuario-screen {
  .el-table__fixed-right-patch {
    width: 0 !important;
  }
}
</style>
